export default __webpack_public_path__ + "locales/az/Ldap.json?hash=eda35df8c81d1325d6e188bad1906c18";